import React from 'react';
import { Button } from 'antd';

export default function DashboardPrimaryActionButton({
  children,
  type = 'primary',
  className,
  ...buttonProps
}) {
  const buttonClassName = [type === 'primary' ? 'dashboard-primary-action-button' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <Button type={type} className={buttonClassName} {...buttonProps}>
      {children}
    </Button>
  );
}
